import React from 'react'
import { Card } from 'antd'
import UnitTestsHistogram from './UnitTestsHistogram'
import { useParams } from 'react-router'

const UnitTestsHistogramCard = () => {
    const { token } = useParams()

    return (
        <Card title='Unit Tests Passed'>
            <UnitTestsHistogram token={token} />
        </Card>
    )
}

export default UnitTestsHistogramCard
